export const PencilEditIcon = (props) => (
  <svg
    className={props.className}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.67676 3.18555L13.5759 8.08472L7.34849 14.3122L2.44932 14.3122L2.44932 9.41299L8.67676 3.18555ZM8.67676 6.01397L4.44932 10.2414V12.3122H6.52006L10.7475 8.08472L8.67676 6.01397Z"
      fill="#4187F5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.87868 2.98363C10.0503 1.81205 11.9497 1.81205 13.1213 2.98362L13.7779 3.64016C14.9494 4.81173 14.9494 6.71123 13.7779 7.8828L12.8688 8.79189L11.4545 7.37768L12.3636 6.46859C12.7542 6.07806 12.7542 5.4449 12.3636 5.05437L11.7071 4.39784C11.3166 4.00731 10.6834 4.00731 10.2929 4.39784L9.3838 5.30693L7.96959 3.89272L8.87868 2.98363Z"
      fill="#4187F5"
    />
  </svg>
);
